import React, { useState, useEffect, useContext, createContext } from "react";

const ScrollContext = createContext(0);

export const ScrollProvider = ({ children }: { children: React.ReactNode }) => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScroll(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return React.createElement(
    ScrollContext.Provider,
    { value: scroll },
    children
  );
};

export const useScroll = () => useContext(ScrollContext);
